import React from "react";
import {useObservableBoxValue} from "@morningtrain/react-helpers";
import {useLocale} from "@morningtrain/react-translations";
import {Env} from "@morningtrain/helpers";

export default function useCurrentLocale() {

    const localeBox = useLocale();

    const [locale, setLocale] = useObservableBoxValue(localeBox);

    function setLocaleOverride(nextLocale) {
        setLocale(nextLocale);
        Env.set('app.locale', nextLocale);
    }

    return [locale, setLocaleOverride];
}
